import { userPreferencesDefaults } from "./user-preferences-defaults";
import { negativeNumberFormats } from "components/modal/settings/negative-number-formats";
import { appStore } from "index";
export const tooltipCurrencyOptions = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
export const tooltipUnitOptions = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
export const getFormatterAndRegion = () => {
    const settings = appStore.getState().settings.current;
    const negativeNumberFormat = settings.negativeNumberFormat ?? userPreferencesDefaults.negativeNumberFormat;
    const region = settings.region ?? userPreferencesDefaults.region;
    const formatter = negativeNumberFormats[negativeNumberFormat].format;
    return { formatter, region };
};
const getCompactUnit = (divider, region) => {
    const last = new Intl.NumberFormat(region, { notation: "compact" }).formatToParts(Number(divider))
        .pop();
    let unit = "";
    if (last && last?.type === "compact") {
        unit = last?.value.toUpperCase();
    }
    return unit;
};
export const getCompactUnitData = (region, value, formatUnit) => {
    let divider = 1;
    const MILLION = 1000000;
    const BILLION = 1000000000;
    switch (formatUnit.toLowerCase()) {
        case "million":
            divider = MILLION;
            break;
        case "billion":
            divider = BILLION;
            break;
        default: break;
    }
    switch (typeof value) {
        case "number":
            return [value / divider, getCompactUnit(divider, region)];
        case "bigint":
            return [value / BigInt(divider), getCompactUnit(divider, region)];
        default:
            return [0, getCompactUnit(divider, region)];
    }
};
